/* istanbul ignore file */
/**
 * Button component theme configuration.
 */

export const buttonComponentConfig = {
  button: {
    root: {
      borderRadius: '{border.radius.sm}',
      roundedBorderRadius: '{border.radius.full}',
      gap: '8px',
      paddingX: '16px',
      paddingY: '6px',
      iconOnlyWidth: '32px',
      sm: {
        fontSize: '14px',
        paddingX: '10px',
        paddingY: '3px',
      },
      lg: {
        fontSize: '14px',
        paddingX: '20px',
        paddingY: '9px',
      },
      label: {
        fontWeight: '400',
      },
      raisedShadow:
        '0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)',
      focusRing: {
        width: '{focus.ring.width}',
        style: '{focus.ring.style}',
        offset: '{focus.ring.offset}',
      },
      badgeSize: '16px',
      transitionDuration: '{form.field.transition.duration}',
    },
    colorScheme: {
      light: {
        root: {
          primary: {
            background: '{primary.color}',
            hoverBackground: '{primary.color}',
            activeBackground: '{primary.color}',
            borderColor: '{primary.color}',
            hoverBorderColor: '{primary.color}',
            activeBorderColor: '{primary.color}',
            color: '{surface.0}',
            hoverColor: '{surface.0}',
            activeColor: '{surface.0}',
            focusRing: {
              color: '{primary.color}',
              shadow: 'none',
            },
          },
        },
        outlined: {
          primary: {
            hoverBackground: '{surface.50}',
            activeBackground: '{surface.100}',
            borderColor: '{primary.color}',
            color: '{primary.color}',
          },
        },
        text: {
          primary: {
            hoverBackground: '{surface.50}',
            activeBackground: '{surface.50}',
            color: '{primary.color}',
          },
          secondary: {
            hoverBackground: '{surface.50}',
            activeBackground: '{surface.50}',
            color: '{surface.600}',
          },
        },
      },
    },
  },
};
